/**
 * The cookie banner should be somehow re-opened when the user clicks on a link in the footer
 * This script checks whether that link will get clicked and will reload completely the site displaying the banner
 */

import { add } from 'bianco.events';
import { deleteCookie } from './cookie';

const SHOW_COOKIES_HASH = '#show_cookies_policy';
const COOKIES_CONSENT_NAME = 'cookie_consent';

const onHashChange = () => {
    const { hash } = window.location;

    if (hash !== SHOW_COOKIES_HASH) {
        return;
    }

    deleteCookie({ key: COOKIES_CONSENT_NAME, path: '/' });
    window.location.reload();
};

// remove the cookie consent hash if the page was loaded with it already set
if (window.location.hash === SHOW_COOKIES_HASH) {
    window.location.hash = '';
}

add(window, 'hashchange', onHashChange);
